const backend_url = 'https://smartbeans.informatik.uni-goettingen.de/api';

export default backend_url;
